import { Controller } from '@hotwired/stimulus';
import {
    dispatchEvent,
    subscribeEvent,
    unsubscribeEvent,
    CustomEventNames
} from '@shared/script/eventDispatcher';


export default class extends Controller {
    static values = {
        id: String
    };

    static targets = ['modal'];

    declare modalTarget: HTMLDialogElement;

    connect(): void {
        subscribeEvent(CustomEventNames.ModalOpen, this.open.bind(this));
    }

    disconnect(): void {
        unsubscribeEvent(CustomEventNames.ModalOpen, this.open.bind(this));
    }

    open({ modalId }): void {
        if (modalId === this.idValue) {
            this.modalTarget.showModal();
        }
    }

    close(): void {
        this.modalTarget.close();
        dispatchEvent(CustomEventNames.ModalClose, { modalId: this.idValue });
    }

    closeOnBackdropClick(event: MouseEvent): void {
        const rect: DOMRect = event.currentTarget?.getBoundingClientRect();
        const clickIsOutisdeDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
            rect.left <= event.clientX && event.clientX <= rect.left + rect.width;

        if (!clickIsOutisdeDialog && event.currentTarget === event.target) {
            this.close();
        }
    }
}
